<template>
  <b-modal
    :visible="visible"
    :title="$t('policy_exception.close_exception')"
    :ok-title="$t('policy_exception.workflow.confirm_title')"
    :cancel-title="$t('actions.cancel')"
    ok-variant="warning"
    :ok-disabled="!closeReasonTrimmed"
    @hidden="$emit('close')"
    @ok.prevent="handleSubmit"
  >
    <p class="mb-2">{{ $t('policy_exception.close_exception_message') }}</p>
    <b-form-group :label="$t('policy_exception.close_reason')" label-for="close-reason" class="mb-2">
      <b-form-textarea
        id="close-reason"
        v-model="closeReason"
        rows="3"
        :placeholder="$t('policy_exception.close_reason_placeholder')"
        required
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'

export default {
  name: 'CloseExceptionModal',
  props: {
    visible: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const closeReason = ref('')

    const closeReasonTrimmed = computed(() => (closeReason.value || '').trim().length > 0)

    watch(
      () => props.visible,
      (visible) => {
        if (!visible) closeReason.value = ''
      }
    )

    const handleSubmit = () => {
      if (!closeReasonTrimmed.value) return
      emit('confirm', { close_reason: closeReason.value.trim() })
    }

    return {
      closeReason,
      closeReasonTrimmed,
      handleSubmit,
    }
  },
}
</script>
